import { OfferingDateDataFragment } from 'graphql/bindings/AdminBindings'
import React, { Fragment, ReactNode } from 'react'
import moment from 'moment'

export const CampaignEmailWarning: React.FC<{
  content: ReactNode
  dateType: 'invitation' | 'reminder'
  otherOfferings: OfferingDateDataFragment[]
}> = ({ content, dateType, otherOfferings }) => {
  const getOfferingDate = (offering: OfferingDateDataFragment): Date => {
    return dateType === 'invitation' ? offering.available_from : offering.auto_reminder_email_at
  }

  return (
    <Fragment>
      <div>{content}</div>
      {otherOfferings.map(offering => (
        <div key={offering.id}>
          {`${moment(getOfferingDate(offering)).format('M/D/YYYY h:mm a')}: ${offering.name}`}
        </div>
      ))}
    </Fragment>
  )
}
